var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortrait24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.997V5.03c0-.567.21-1.06.644-1.46.419-.385.927-.57 1.514-.57h9.677c.36 0 .708.063 1.024.229.738.388 1.125.986 1.137 1.785.009.452 0 .903 0 1.355v12.562c0 .482-.13.923-.452 1.3-.39.458-.894.717-1.52.76-.107.009-.21.009-.316.009H7.185c-.481 0-.924-.116-1.311-.388-.529-.375-.82-.871-.865-1.493A2.888 2.888 0 015 18.893v-6.899.003zm2.129 0v6.49c0 .29.227.505.531.505h8.679c.03 0 .059 0 .091-.006a.504.504 0 00.443-.515V5.531c0-.316-.224-.528-.558-.528H7.687c-.33 0-.552.212-.552.526V12l-.006-.003z"
  })));
}
export default SvgPortrait24;